import { observer } from 'mobx-react';
import React from 'react';
import { useStore } from '../../../app/data/root.store';
import { getDocTypeIcon } from '../../assets/docsTypes/docTypes';
import { VaultEmptyState } from '../VaultEmptyState/VaultEmptyState';
import { VaultStatusMap } from '../VaultStatuses/VaultStatusMap';
import { LogoLoader } from '../../../../common/components/LogoLoader/LogoLoader';
import { RightArrowIcon } from './icons';
import {
    VaultMobileFileActions,
    VaultMobileFileDetails,
    VaultMobileFileIcon,
    VaultMobileFileInfo,
    VaultMobileFileItem,
    VaultMobileFileListContainer,
    VaultMobileFileName,
    VaultMobileFileStatus,
    VaultMobileRightArrow
} from './VaultMobileList.styles';

export const VaultMobileFileList = observer(() => {
    const { vaultStore } = useStore();

    const handleFileClick = (file) => vaultStore.setSelectedFile(file);

    const formatFileSize = (bytes) => {
        if (!bytes) return '';
        const sizes = ['Bytes', 'KB', 'MB', 'GB'];
        const i = Math.floor(Math.log(bytes) / Math.log(1024));
        return Math.round(bytes / Math.pow(1024, i) * 100) / 100 + ' ' + sizes[i];
    };

    const formatDate = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', {
            month: 'short',
            day: 'numeric',
            year: 'numeric'
        });
    };

    if (vaultStore.isLoading && vaultStore.files.length === 0) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', padding: '64px 0' }}>
                <LogoLoader />
            </div>
        );
    }

    if (!vaultStore.files.length) {
        if (vaultStore.hasActiveFilters) {
            return <VaultEmptyState isMobile />;
        }
    }

    return (
        <VaultMobileFileListContainer>
            {vaultStore.files.map((file) => {
                const fileExtension = file.originalName?.split('.').pop()?.toLowerCase();
                const fileIcon = getDocTypeIcon(fileExtension);

                return (
                    <VaultMobileFileItem key={file.id} onClick={() => handleFileClick(file)}>
                        <VaultMobileFileIcon>
                            {fileIcon}
                        </VaultMobileFileIcon>

                        <VaultMobileFileInfo>
                            <VaultMobileFileName>
                                {file.displayName || file.originalName}
                            </VaultMobileFileName>
                            <VaultMobileFileDetails>
                                {file.category && <span>{file.category}</span>}
                                {file.fileSize && <span>• {formatFileSize(file.fileSize)}</span>}
                                {file.uploadDate && <span>• {formatDate(file.uploadDate)}</span>}
                            </VaultMobileFileDetails>
                        </VaultMobileFileInfo>

                        <VaultMobileFileActions>
                            {file.status && (
                                <VaultMobileFileStatus>
                                    {VaultStatusMap(file.status, true)}
                                </VaultMobileFileStatus>
                            )}
                            <VaultMobileRightArrow>
                                <RightArrowIcon />
                            </VaultMobileRightArrow>
                        </VaultMobileFileActions>
                    </VaultMobileFileItem>
                );
            })}
        </VaultMobileFileListContainer>
    );
}); 